export const indexUserEntriesPath: string = "/users/entries";
